import { AlgoliaHit } from 'instantsearch.js';
import { Base_Unit_Type_Enum, Measurement_Unit_Enum } from '@kheops/graphql';
import { FormatMeasurementUnit, formatPriceByBillingType, round } from '@kheops/utils';
import { ProductHit } from '../../search/search';
import { ProductCardData } from '../../products/common/product-card.types';
import { mapAlgoliaHitToProductCardData } from '../../products/common/product-card.mappers';
import { UserDeliveryZone } from '../models/user.models';
import { insensitiveStringIncludes } from './common.utils';

export default class SearchUtils {
  static getFormatedUnitPrice(product: ProductCardData, formatter: (value: number | bigint) => string): string {
    return product.baseUnitType === Base_Unit_Type_Enum.Bulk
      ? `${formatter(round(product.volumePrice.value))}/${FormatMeasurementUnit(product.volumePrice.unit as Measurement_Unit_Enum, 'fr', 1)}`
      : formatPriceByBillingType(formatter(round(product.price / product.unitQuantity)), product.billingType);
  }

  static getFormatedUnitPriceFromAlgoliaHit(hit: AlgoliaHit<ProductHit>, formatter: (value: number | bigint) => string): string {
    return SearchUtils.getFormatedUnitPrice(mapAlgoliaHitToProductCardData(hit), formatter);
  }

  static getFormatedSuggestedRetailPrice(product: ProductCardData, formatter: (value: number | bigint) => string): string {
    return product.baseUnitType === Base_Unit_Type_Enum.Bulk
      ? `${formatter(product.suggestedRetailPrice!)}/${FormatMeasurementUnit(product.volumePrice.unit as Measurement_Unit_Enum, 'fr', 1)}`
      : formatPriceByBillingType(formatter(product.suggestedRetailPrice!), product.billingType);
  }

  static getFormatedSuggestedRetailPriceFromAlgoliaHit(hit: AlgoliaHit<ProductHit>, formatter: (value: number | bigint) => string): string {
    return SearchUtils.getFormatedSuggestedRetailPrice(mapAlgoliaHitToProductCardData(hit), formatter);
  }

  /**
   * This function computes wether an area can be delivered given reference delivery areas
   * @param referenceDeliveryAreas
   * @param administrativeAreaLvl2ToDeliver  This has to be an administrative area of level 2
   */
  static canItDeliverAnArea(referenceDeliveryAreas: UserDeliveryZone[] | string[] | undefined, administrativeAreaLvl2ToDeliver: string): boolean {
    if (referenceDeliveryAreas === undefined || referenceDeliveryAreas.length === 0) {
      // Here we fallback on can deliver if company did not specify their delivery zones
      return true;
    }

    if (typeof referenceDeliveryAreas[0] === 'string') {
      return (referenceDeliveryAreas as string[]).some((area) => insensitiveStringIncludes(area, administrativeAreaLvl2ToDeliver || '')) || (referenceDeliveryAreas as string[]).includes('ALL_AREAS');
    }

    return (referenceDeliveryAreas as UserDeliveryZone[]).some((deliveryZone) => (
      deliveryZone.administrative_areas[0].area === 'ALL_AREAS'
      || deliveryZone.administrative_areas.some((administrativeArea) => insensitiveStringIncludes(administrativeArea.area, administrativeAreaLvl2ToDeliver || ''))
    ));
  }
}
